/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateExerciseFactDTO
 */
export interface UpdateExerciseFactDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseFactDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseFactDTO
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateExerciseFactDTO
     */
    glossaryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseFactDTO
     */
    exerciseId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExerciseFactDTO
     */
    id: string;
}

/**
 * Check if a given object implements the UpdateExerciseFactDTO interface.
 */
export function instanceOfUpdateExerciseFactDTO(value: object): value is UpdateExerciseFactDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateExerciseFactDTOFromJSON(json: any): UpdateExerciseFactDTO {
    return UpdateExerciseFactDTOFromJSONTyped(json, false);
}

export function UpdateExerciseFactDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExerciseFactDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'glossaryIds': json['glossaryIds'] == null ? undefined : json['glossaryIds'],
        'exerciseId': json['exerciseId'] == null ? undefined : json['exerciseId'],
        'id': json['id'],
    };
}

export function UpdateExerciseFactDTOToJSON(json: any): UpdateExerciseFactDTO {
    return UpdateExerciseFactDTOToJSONTyped(json, false);
}

export function UpdateExerciseFactDTOToJSONTyped(value?: UpdateExerciseFactDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'glossaryIds': value['glossaryIds'],
        'exerciseId': value['exerciseId'],
        'id': value['id'],
    };
}

